module.exports = __webpack_public_path__ + "img/tuto5.c8bbca64.png";